<ng-container *ngIf="freeWallConfig && renderedMicrositePromise | async">
  <div *ngIf="micrositeLinkPromise | async as micrositeLink"
       class="microsite-container"
       [style.height]="height ? height + 'px' : undefined" [style.padding-top]="height ? undefined : 900 /16 + '%'" >
    <iframe class="microsite"
            [src]="micrositeLink | safe">
    </iframe>
  </div>
</ng-container>
